import { useState } from "react";
import { Info } from "lucide-react";
import Button from "@imminently/decisively-ui/Button";
import Dialog from "@imminently/decisively-ui/Dialog";
import { DialogHeader } from "@/ui/dialogs/DialogHeader";
import { EVENT_TYPE_INFO } from "@packages/commons";
import { EventIcon } from "./EventIcon";

const allEventTypes = Object.values(EVENT_TYPE_INFO).filter(event => event.canConnect).sort(
  (a, b) => a.category.localeCompare(b.category) || a.name.localeCompare(b.name),
);

export const EventTypesButton = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button type="button" size="sm" variant="ghost" label="Event types" onClick={() => setOpen(true)}>
        <Info size={16} />
        Event types
      </Button>
      <Dialog
        intent="cover"
        open={open}
        onOpenChange={setOpen}
      >
          <Dialog.Content>
            <DialogHeader
              title="Event Types"
              description="All event types can be selected by connectors."
            />
            <Dialog.Body className="min-h-0 flex-1 overflow-auto">
              <div className="shrink-0 border border-border">
                <table className="min-w-full border-collapse text-sm">
                  <thead className="bg-muted/40 text-left">
                    <tr>
                      <th className="border-b border-border px-3 py-2 font-medium">Event</th>
                      <th className="border-b border-border px-3 py-2 font-medium">Category</th>
                      <th className="border-b border-border px-3 py-2 font-medium">Description</th>
                      <th className="border-b border-border px-3 py-2 font-medium">Facts</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allEventTypes.map((event) => (
                      <tr
                        key={event.id}
                        className="border-b border-border last:border-b-0"
                      >
                        <td className="px-3 py-3 align-top">
                          <div className="flex items-start gap-3">
                            <EventIcon eventType={event.id} className="mt-0.5 shrink-0 text-textSecondary" />
                            <div className="min-w-0">
                              <div className="font-medium">{event.name}</div>
                              <div className="text-xs text-textSecondary">{event.id}</div>
                            </div>
                          </div>
                        </td>
                        <td className="px-3 py-3 align-top capitalize text-textSecondary">{event.category}</td>
                        <td className="px-3 py-3 align-top text-textSecondary">{event.description}</td>
                        <td className="px-3 py-3 align-top text-textSecondary">
                          {event.factInfo.map(fact => <div key={fact.key} className="mb-1">
                            {fact.label.replace("{id}", "(any)")} <code className="text-xs">{fact.key}</code>
                            <span className="ml-1 text-xs">({fact.valueType})</span>
                            <div className="break-all text-xs">Example: <code>{String(fact.exampleValue)}</code></div>
                          </div>)}
                          {!event.factInfo.length && "No registered facts"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Dialog.Body>
            <Dialog.Actions>
              <Dialog.Actions.PrimaryButton
                label="Close"
                onClick={() => setOpen(false)}
              >
                Close
              </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
          </Dialog.Content>
      </Dialog>
    </>
  );
};
